import React from 'react';

import {
  CreateUpdateContractEstimateItemDto,
  GetContractExtendedDto,
  GetEstimateItemContractDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';

import { TableColumn } from './ContractEstimateItemGrid';
import { getContractItem, getSavedItem } from './contractEstimateItemGridUtils';

interface ContractEstimateItemGridRowProps {
  extendedContract?: GetContractExtendedDto;
  contractEstimateItems: CreateUpdateContractEstimateItemDto[];
  availableEstimateItems: GetEstimateItemContractDto[];
  columns: TableColumn[];
  estimateItem: GetEstimateItemContractDto;
}

export const ContractEstimateItemGridRow: React.FC<
  ContractEstimateItemGridRowProps
> = props => {
  return (
    <tr key={props.estimateItem.id} className="align-middle">
      {props.columns.map((col, index) => {
        const contractEstimateItem = getContractItem(
          props.estimateItem.id,
          props.contractEstimateItems,
        );
        const savedItem = getSavedItem(
          contractEstimateItem,
          props.extendedContract?.contractEstimateItems,
        );

        return (
          <td
            key={`${props.estimateItem.id}-${col.header}-${index} `}
            className={col.tdCssClass}
          >
            {col.renderCell(
              props.estimateItem,
              contractEstimateItem,
              savedItem,
            )}
          </td>
        );
      })}
    </tr>
  );
};
